import React from 'react';
import { Box, Button, Paper, Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import LimitedBackdropLoading from 'components/Loading/LimitedBackdropLoading';
import { setLoading, unSetLoading, setDownloadLink } from 'redux/slices/dataSlice';
import { generateLinks, resetState } from 'redux/slices/filesSlice';
import {
  appliedFilterByOperationStatusSelector,
  appliedFilterByOperationDateSelector,
  appliedFilterByNameSelector,
  appliedFilterByLastNameSelector,
  appliedFilterByDocumentSelector,
  appliedFilterByBatchSelector,
  appliedFilterByOperationTypesSelector,
  filesSelector,
} from 'redux/selectors';
import { STATUS } from 'constants/thunkStates';

const StyledPaper = styled(Paper)`
  padding: 2rem;
  margin: auto;
  width: 40vw;
  max-height: 90vh;
  overflow: auto;
  text-align: center;
  border: 2px solid #000;
  box-shadow: ${(p) => p.theme.shadows[5]};
`;

function ExportLinksModal({ handleClose }) {
  const dispatch = useDispatch();
  const operationStatus = useSelector(appliedFilterByOperationStatusSelector) || '';
  const operationDate = useSelector(appliedFilterByOperationDateSelector) || '';
  const name = useSelector(appliedFilterByNameSelector) || '';
  const lastName = useSelector(appliedFilterByLastNameSelector) || '';
  const document = useSelector(appliedFilterByDocumentSelector) || '';
  const batch = useSelector(appliedFilterByBatchSelector || '');
  const type = useSelector(appliedFilterByOperationTypesSelector || '');
  const { status, error } = useSelector(filesSelector);

  const handleGenerateLinks = () => {
    dispatch(setLoading('createLinks'));
    dispatch(generateLinks({ operationStatus, operationDate, name, lastName, document, batch, type }))
      .then((res) => {
        if (res.payload.code  !== 200) {
          dispatch(resetState());
          dispatch(unSetLoading('createLinks'));
          return
        }
        dispatch(unSetLoading('createLinks'));
        dispatch(setDownloadLink({ type: 'createLinks', link: res.payload.link }))
      });
    handleClose();
  };

  return (
    <StyledPaper elevation={3}>
      <Typography variant="text" gutterBottom>
        ¿Desea generar un TXT de los clientes filtrados?
      </Typography>
      {status === STATUS.pending && <LimitedBackdropLoading size={50} />}
      {status === STATUS.error && (error.description || error.message)}
      <Box
        mt={3}
        p={2}
        display="flex"
        flexDirection="row"
        flexGrow={1}
        justifyContent="center"
      >
        <Box p={1}>
          <Button
            onClick={handleClose}
            fullWidth
            color="secondary"
            variant="contained"
            disabled={status === STATUS.pending ? true : false}
          >
            Cancelar
          </Button>
        </Box>
        <Box p={1}>
          <Button
            onClick={handleGenerateLinks}
            fullWidth
            color="primary"
            variant="contained"
            disabled={status === STATUS.pending ? true : false}
          >
            Generar
          </Button>
        </Box>
      </Box>
    </StyledPaper>
  );
}

export default ExportLinksModal;
